export const ENUM_FILOGIX_STATUS = {
  inProgress: "in-progress",
  accepted: "accepted",
  approved: "approved",
  confirmed: "confirmed",
  readyToClose: "ready-to-close",
  paid: "paid",
  closed: "closed",
  declined: "declined",
  cancelled: "cancelled",
  failed: "failed",
  processing: "processing"
};
export const LABELS_CLIENT_APPLICATION_STATUS = {
  new: "new",
  pending: "pending",
  submitted: "submitted",
  "in-review": "under review",
  completed: "completed",
  cancelled: "cancelled"
};
export const CLIENT_APPLICATION_STATUS = {
  new: "new",
  pending: "pending",
  submitted: "submitted",
  inReview: "in-review",
  completed: "completed",
  cancelled: "cancelled"
};
export const MORTGAGE_FRANCHISE = {
  Axiom: "Axiom",
  Centum: "Centum",
  Dominion: "Dominion",
  Independent: "Independent",
  Invis: "Invis",
  Verico: "Verico",
  "Mortgage Alliance": "Mortgage Alliance",
  "Mortgage Architects": "Mortgage Architects",
  "Mortgage Intelligence": "Mortgage Intelligence",
  "Oriana Financial Group of Canada": "Oriana Financial Group of Canada",
  "The Mortgage Centre": "The Mortgage Centre",
  "TMG - The Mortgage Group": "TMG - The Mortgage Group",
  Other: "Other"
};
export const CLIENT_APPLICATION_STATUS_FOR_REPORT = {
  submitted: "submitted",
  declined: "declined",
  pending: "pending",
  approved: "approved",
  accepted: "accepted",
  closed: "closed",
  paid: "paid",
  cancelled: "cancelled"
};
export const ALL_CLIENT_APPLICATION_STATUS_FOR_REPORT = {
  new: "new",
  "in-progress": "in-progress",
  inReview: "in-review",
  submitted: "submitted",
  declined: "declined",
  pending: "pending",
  approved: "approved",
  accepted: "accepted",
  "ready-to-close": "ready-to-close",
  closed: "closed",
  confirmed: "confirmed",
  paid: "paid",
  completed: "completed",
  cancelled: "cancelled"
};
export const RISK_LEVEL = {
  high: "high",
  medium: "medium"
};
export var SORT_ORDER_E;
(function (SORT_ORDER_E) {
  SORT_ORDER_E["desc"] = "desc";
  SORT_ORDER_E["asc"] = "asc";
})(SORT_ORDER_E || (SORT_ORDER_E = {}));